module.exports = __webpack_public_path__ + "1ac60bdd22bc0f429a45076d1a0d371a.MP3";